
// Fixed navbar
$(window).on("scroll", function(){
    if($(this).scrollTop() > 0){
        $("body").addClass("fixed-navbar");
    }else{
        $("body").removeClass("fixed-navbar");
    }
});


//Menu
$('.toggle-menu').on('click', function(){
    $('body').toggleClass('menu-is-open');
});


// Lazy BG
let lazy_bg_loaded = false;
function loadLazyBg(){
    if($(window).scrollTop() > 0){
        lazy_bg_loaded = true;
        $("body").addClass('load-lazy-bg');
    }
}

loadLazyBg();

$(window).on("scroll", function(){
    if(!lazy_bg_loaded){
        loadLazyBg();
    }
});


//Animate scroll
function animateScroll(dest){
    if($(dest).length){
        var scrollPosition = $(dest).offset().top - 110;
        $('html,body').animate({
            scrollTop: scrollPosition
        }, 500);
    }
};


//Animate scroll on home page menu links
$('a:not(".ignore")').on("click", function(e){
    var url = $(this).attr('href');
    if(url.indexOf('#') == 0 || (url.indexOf('#') > -1 && url.indexOf(window.location.href.split('#')[0]) == 0)){
        var dest = "#"+url.substring(url.indexOf('#')+1);
        
        if($(dest).length){
            e.preventDefault();
            animateScroll(dest);
        }
    }
});


// Animations
$.fn.shouldAnimate = function(){
    var win = $(window);
    var topOffset = win.innerHeight() / 8;

    var viewport = {
        top : win.scrollTop() - topOffset,
        left : win.scrollLeft()
    };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top /*|| viewport.top > bounds.bottom*/));
};

function runAnimations(){
    $.each($('.animate'), function(index, element){
        if($(this).shouldAnimate()){
            $(this).removeClass('animate');
            $(this).addClass('animated');
            $(this).addClass($(this).data('animation'));
        }
    });
}

runAnimations();

$(document).on('scroll', function(){
    runAnimations();
});


// Home pricing video
function moveVideo(position){
    if(position >= 100) position = 99; // This fixes a bug in iOS Safari
    let video = document.getElementById('home-pricing-calc-video');
    let duration = video.duration;
    videoPosition = (duration / 100) * position;
    if(videoPosition > duration) videoPosition = duration;
    if(!$.isNumeric(videoPosition)) videoPosition = 0;
    if(videoPosition > duration) videoPosition = duration;
    video.currentTime = videoPosition;    
}

function pauseVideo(){
    let video = document.getElementById('home-pricing-calc-video');
    if(video != null){
        video.pause();
        video.currentTime = 0;
    }
}
pauseVideo();


// Home pricing amount
function setHomePrice(position){
    let price = 1;
    if(position >= 25 && position < 75){
        price = 2;
    }else if(position >= 75){
        price = 3;
    }

    let monthly = $('.home-pricing-calc-monthly-amount').data('level-'+price);
    $('.home-pricing-calc-monthly-amount').html(monthly);

    let oneTime = $('.home-pricing-calc-one-time-amount').data('level-'+price);
    $('.home-pricing-calc-one-time-amount').html(oneTime);
}


// Home pricing slider
$( ".home-pricing-slider" ).slider();
$( ".home-pricing-slider" ).on('slide', function(){
    moveVideo($(this).slider('option', 'value'));
    setHomePrice($(this).slider('option', 'value'));
})


// Home benefits
$('.home-benefits-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    dots: false,
    //autoplay: true,
    autoplayTimeout: 7000,
    margin: 50,
    lazyLoad: true,
    navText: [
        '<i class="las la-chevron-circle-left"></i>',
        '<i class="las la-chevron-circle-right"></i>'
    ]
});


// Home media
$('.home-media-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    //autoplay: true,
    autoplayTimeout: 7000,
    margin: 50,
    lazyLoad: true,
    navText: [
        '<i class="las la-chevron-circle-left"></i>',
        '<i class="las la-chevron-circle-right"></i>'
    ],
});


// FAQ
$('.toggle-faq-answer').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('question-open');
    $(this).siblings('.faq-answer').slideToggle();
});


// Reviews carousel
$('.reviews-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    //autoplay: true,
    autoplayTimeout: 7000,
    margin: 50,
    lazyLoad: true,
    navText: [
        '<i class="las la-chevron-circle-left"></i>',
        '<i class="las la-chevron-circle-right"></i>'
    ],
});


// Play material video
$('.box-material-video').on('click', function(e){
    let id = $(this).attr('href');
    $(id+' video').get(0).play();
});

$(document).on('click', '.lity-close', function(e){
    $('.box-material-video-player video').each(function(){
        $(this).get(0).pause();
    });
});


// Assessment page - Global
let result = null;
let showSection5 = true;
let showSection6 = true;
let sendEmail = false;

function goToSection(section = 1){
    if(section == null) section = 1;

    if(section == 5 && !showSection5){
        goToSection(6);
        return false;
    }
    
    if(section == 6 && !showSection6){
        goToSection(7);
        return false;
    }

    $('.assessment-section').hide();
    $('#assessment-section-'+section).fadeIn();
}

// Assessment page - Section 1
$('#assessment-section-1-button').on('click', function(e){
    e.preventDefault();
    goToSection(2);
});

// Assessment page - Section 2
$('#assessment-section-2-button-1').on('click', function(e){
    e.preventDefault();
    appendFormData($('#assessment-section-2 h3').text(), $('#assessment-section-2-button-1').text());
    goToSection(3);
});

$('#assessment-section-2-button-2').on('click', function(e){
    e.preventDefault();
    appendFormData($('#assessment-section-2 h3').text(), $('#assessment-section-2-button-2').text());
    goToSection(3);
});

// Assessment page - Section 3
$('#assessment-section-3-button-1').on('click', function(e){
    e.preventDefault();
    appendFormData($('#assessment-section-3 h3').text(), $('#assessment-section-3-button-1').text());
    sendForm(103);
});
$('#assessment-section-3-button-2').on('click', function(e){
    e.preventDefault();
    appendFormData($('#assessment-section-3 h3').text(), $('#assessment-section-3-button-1').text());
    goToSection(4);
});

// Assessment page - Section 4
$('#assessment-section-4-button').on('click', function(e){
    e.preventDefault();
    if($('[name="answer-3"]:checked').length == 0) return false;
    
    let answer = '';
    $.each($('[name="answer-3"]'), function(){
        if (answer != '') answer += ', ';
        answer += $(this).val();
    });
    appendFormData($('#assessment-section-4 h3').text(), answer);

    if($('.section-4-answer-1:checked').length && !$('.section-4-answer-2:checked').length) showSection6 = false;
    if(!$('.section-4-answer-1:checked').length && $('.section-4-answer-2:checked').length) showSection5 = false;

    goToSection(5);
});

// Assessment page - Section 5
$('#assessment-section-5-button').on('click', function(e){
    e.preventDefault();
    if($('[name="answer-4"]:checked').length == 0) return false;
    
    let answer = $('[name="answer-4"]:checked').val();
    appendFormData($('#assessment-section-5 h3').text(), answer);

    if($('.answer-4-c:checked').length) result = 101;
    goToSection(6);
});

// Assessment page - Section 6
$('#assessment-section-6-button').on('click', function(e){
    e.preventDefault();
    if($('[name="answer-5"]:checked').length == 0) return false;
    
    let answer = $('[name="answer-5"]:checked').val();
    appendFormData($('#assessment-section-6 h3').text(), answer);

    goToSection(7);
});

// Assessment page - Section 7
$('#assessment-section-7-button-1').on('click', function(e){
    e.preventDefault();
    
    appendFormData($('#assessment-section-7 h3').text(), $('#assessment-section-7-button-1').text());

    if(result == null) result = 102;
    sendForm(result);
});
$('#assessment-section-7-button-2').on('click', function(e){
    e.preventDefault();
    
    appendFormData($('#assessment-section-7 h3').text(), $('#assessment-section-7-button-2').text());
    
    if(result == null) result = 102;
    sendForm(result);
});

// Assessment page - submit data
function appendFormData(field, value){
    $('.assessment-form form').append('<input type="hidden" name="contact['+field+']" value="'+value+'">');
}

function sendForm(result = 102){
    if(sendEmail){
        setCookie('assessmentresult', result);
        $('.assessment-form form').submit();
    }else{
        goToSection(result);
    }
}

function loadResult(){
    let assessment_result = getCookie('assessmentresult');
    eraseCookie('assessmentresult');
    goToSection(assessment_result);
}

if($('.assessment-form').length){
    var url = new URL(location.href);
    var posted = url.searchParams.get("contact_posted");
    if(posted) loadResult();
}

// Cookie manager
function setCookie(name,value,days = 1) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}